module.exports = __webpack_public_path__ + "static/media/home-small-placeholder.808e1250.webp";